import React, {useEffect, useState} from 'react'
import {useSelector, useDispatch} from "react-redux";
import _ from 'lodash';
import classNames from "classnames";
import {timeDayToDisplayTimeslot} from "./meetings/utils";
import MeetingTimeslotsConfirmModal from "./meetings/meeting_timeslots_confirm_modal";
import axios from "axios";
import BookedMeetings from "./meetings/booked_meetings";
import MeetingsManager from "./meetings_calendar/meetings_manager";


export default function Meetings() {
  const account = useSelector(state => state.account)
  const meetingGetConfirmedTimeslotsUrl = useSelector(state => state.meetingGetConfirmedTimeslotsUrl)
  const [isLoading, setIsLoading] = useState(true)
  const [selectedTimeslots, setSelectedTimeslots] = useState([])
  const [confirmedTimeslots, setConfirmedTimeslots] = useState([])
  const [showModal, setShowModal] = useState(false)
  const hasNotConfirmedSelectedTimeslots = !_.isEmpty(selectedTimeslots)
  const daysRange = _.range(3, 6)
  const hoursRange = _.range(0, 24)

  useEffect(() => {
    axios({
      method: "post",
      url: meetingGetConfirmedTimeslotsUrl
    }).then(
      (data) => {
        setConfirmedTimeslots(data.data.confirmedTimeslots)
        setSelectedTimeslots([])
      },
      (error) => {
        console.error(error)
        alert(error)
      }).then(function () {
      setIsLoading(false)
    })
  }, [])

  const toggleTimeslot = (day, hour) => {
    const isTimeslotSelected = selectedTimeslots.some((timeslot) => timeslot.day == day && timeslot.hour == hour)

    if (isTimeslotSelected) {
      setSelectedTimeslots(selectedTimeslots.filter((timeslot) => !(timeslot.day == day && timeslot.hour == hour)))
    } else {
      setSelectedTimeslots([...selectedTimeslots, {day, hour}])
    }
  }

  const isSelected = (day, hour) => {
    return selectedTimeslots.some(timeslot => timeslot.day == day && timeslot.hour == hour)
  }

  const isConfirmed = (day, hour) => {
    return confirmedTimeslots.some(timeslot => timeslot.day == day && timeslot.hour == hour)
  }

  const onConfirmedTimeslotsUpdated = (newTimeslots) => {
    setConfirmedTimeslots(newTimeslots)
    setSelectedTimeslots([])
  }


  if (isLoading) {
    return <div className="row no-gutters">
      <div className="col-12">
        <div className={"text-center"}>
          <div className="spinner-border text-dark" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  }

  return <>
    {showModal && <MeetingTimeslotsConfirmModal
      onUpdated={onConfirmedTimeslotsUpdated}
      onClose={() => setShowModal(false)}
      selectedTimeslots={selectedTimeslots}/>}
    <div className="row no-gutters">
      <div className="col-12">
        <div className="p-4 m-4 shadow">
          <div className="row">
            <div className="col-md-8">
              <h1>Meetings</h1>
              <h5>You are logged in as: {account.name}</h5>
              <p>
                Manage your availabilities here.
              </p>
            </div>
            <div className="col-md-4 text-right">
            </div>
          </div>
        </div>
      </div>
      <div className="col-12">
        <div className="row p-4">
          <MeetingsManager/>
        </div>
      </div>
    </div>
  </>;
}
